export default __webpack_public_path__ + "static/media/Vibhor jain.e1d4c68f.jpg";